import {StageLayer} from "@nolimitcity/slot-launcher/bin/StageLayer";
import {gsap} from "gsap";
import {HTH} from "../HTH";
import {HTHHelper} from "../utils/HTHHelper";

export class HTHFSIntro extends PIXI.Container implements StageLayer {
    private _spine: PIXI.spine.Spine;
    private _introContainer: PIXI.Container;
    private _spineMask: PIXI.Sprite;


    constructor() {
        super();
        this.name = "FSIntroView";
        this.init();
    }

    public hideFSIntro(): gsap.core.Timeline {
        const hideFSIntroTL: gsap.core.Timeline = gsap.timeline();
        hideFSIntroTL.add(HTHHelper.playSpineWithTimeline(this._spine, 0, "introfadeout"))
        hideFSIntroTL.to([this, this._spine], {duration: 0.01, alpha: 0});
        hideFSIntroTL.add(HTH.gameViewContainer.hideOverlay(), "<");
        hideFSIntroTL.add(HTH.gameViewContainer.scatterCollector.showScatterCollector(true));

        hideFSIntroTL.add(() => {
            this.visible = false;
            this._spine.visible = false;
            HTH.backgroundElements.setMode(HTH.model.data.nextMode);
            HTHHelper.resetSpineItem(this._spine);
        });
        return hideFSIntroTL;
    }

    public onResize(): void {
        if (!this.visible) {
            return;
        }
        HTH.gameViewContainer.resetOverlay();
    }

    public showFSIntro(): gsap.core.Timeline {
        const tl: gsap.core.Timeline = gsap.timeline();
        this.onResize();
        tl.add(HTH.gameViewContainer.addOverlay(0.2, 0.7), 0);
        tl.add(() => {

            this._spine.visible = true;
            this.visible = true;
            this.alpha = 1;
        }, 0);
        tl.add(HTHHelper.playSpineWithTimeline(this._spine, 0, "introfadein"), 0);
        tl.to(this._spine, {duration: 0.07, alpha: 1}, "<");
        tl.add(() => {
            this._spine.autoUpdate = true;
            this._spine.state.setAnimation(0, "introfadeloop", true);
        })

        return tl;
    }

    private init(): void {
        this._introContainer = new PIXI.Container();
        this._introContainer.name = "intro";
        this.addChild(this._introContainer);

        this._spine = new PIXI.spine.Spine(HTH.assetLoader.getSpineAsset("fsIntro"));
        this._spine.position.set(360, 360);
        this._spine.name = "intro BG";
        this._introContainer.addChild(this._spine);

        this._spineMask = new PIXI.Sprite(HTH.assetLoader.getTextures("introMask")[0]);
        this._spineMask.position.set(360, 360);
        this._spineMask.anchor.set(0.5, 0.5);
        this._spineMask.name = "edgy_mask";
        this._introContainer.addChild(this._spineMask);
        this._introContainer.mask = this._spineMask;

        this.visible = false;
        this.onResize();
    }
}